import { useEffect, useState } from 'react';
import { FaArrowUp } from "react-icons/fa";
import {
  SiGit,
  SiLaravel,
  SiBootstrap,
  SiPhp,
  SiPostgresql,
  SiReact,
  SiTailwindcss,
  SiMysql,
} from "react-icons/si";
import backgroundpage1 from './assets/img/backgroundpg1.png';
import backgroundskill1 from './assets/img/backgroundskill1.png';
import backgroundskill2 from './assets/img/backgroundskill2.png';
import logo from './assets/img/logo.png';
import './App.css';

const navItems = ["Home", "Skills", "Projects", "Experience", "Contact"];
const projectFilters = ["All Projects", "Website", "Mobile", "Desktop", "Script"];
const technicalSkills = [
  { name: "React", icon: SiReact, color: "text-cyan-400" },
  { name: "Laravel", icon: SiLaravel, color: "text-red-500" },
  { name: "Tailwind CSS", icon: SiTailwindcss, color: "text-cyan-300" },
  { name: "Bootstrap", icon: SiBootstrap, color: "text-sky-400" },
  { name: "MySQL", icon: SiMysql, color: "text-green-500" },
  { name: "PHP", icon: SiPhp, color: "text-indigo-300" },
  { name: "PostgreSQL", icon: SiPostgresql, color: "text-sky-300" },
  { name: "Git", icon: SiGit, color: "text-orange-500" },
];
const competencies = [
  { name: "Frontend Development", value: 70 },
  { name: "Backend Development", value: 80 },
  { name: "Database Design", value: 85 },
  { name: "API Development", value: 80 },
  { name: "UI/UX Implementation", value: 70 },
  { name: "Problem Solving", value: 90 },
];
const itSupportSkills = [
  {
    icon: "directory",
    name: "Active Directory",
    label: "User, System Management, Policy",
  },
  {
    icon: "server",
    name: "FOG Server",
    label: "Deployment & Imaging",
  },
  {
    icon: "headset",
    name: "IT Support",
    label: "System & Network Support",
  },
  {
    icon: "deployment",
    name: "System Deployment",
    label: "Imaging & Configuration",
  },
  {
    icon: "network",
    name: "Network Support",
    label: "Drive & User Management",
  },
  {
    icon: "user",
    name: "Technical Support",
    label: "Troubleshooting & Maintenance",
  },
  {
    icon: "tools",
    name: "System Support",
    label: "Hardware & Software Support",
  },
  {
    icon: "help",
    name: "Help Desk Support",
    label: "User Assistance & Issue Resolution",
  },
];
const itSupportCompetencies = [
  { name: "Windows Operating Systems", value: 90 },
  { name: "Active Directory Management", value: 90 },
  { name: "System Deployment (FOG)", value: 85 },
  { name: "Network Support", value: 90 },
  { name: "User & Drive Management", value: 80 },
  { name: "Troubleshooting", value: 95 },
  { name: "Maintenance & Updates", value: 85 },
];
const stats = [
  {
    icon: "user",
    value: "1",
    label: "Years Experience",
  },
  {
    icon: "briefcase",
    value: "4+",
    label: "Projects Completed",
  },
  {
    icon: "network",
    value: "IT Support",
    label: "Active Directory, FOG Server & PFSense Firewall",
  },
  {
    icon: "code",
    value: "Tech Stack",
    label: "React, Laravel, Tailwind, PostgreSQL, Bootstrap, Etc.",
  },
];

const projects = [
  {
    icon: "deployment",
    category: "System Deployment",
    filter: "Deployment",
    title: "Automated System Deployment",
    description:
      "Implemented automated imaging and deployment using FOG Server to streamline setup and reduce manual installation time.",
  },
  {
    icon: "directory",
    category: "Active Directory",
    filter: "System Support",
    title: "AD User & Group Management",
    description:
      "Managed users, groups, and policies in Active Directory to ensure secure access and proper system permissions.",
  },
  {
    icon: "cloud",
    category: "FOG Server",
    filter: "Deployment",
    title: "Imaging & Deployment with FOG",
    description:
      "Configured FOG Server for system imaging, cloning, and deployment across multiple machines in the organization.",
  },
  {
    icon: "network",
    category: "Network Support",
    filter: "Network",
    title: "Network Troubleshooting",
    description:
      "Resolved network issues, configured devices, and ensured stable connectivity across the local network.",
  },
  {
    icon: "tools",
    category: "System Support",
    filter: "System Support",
    title: "System Maintenance & Updates",
    description:
      "Performed regular system maintenance, updates, and optimization to ensure smooth and secure operations.",
  },
  {
    icon: "headset",
    category: "IT Support",
    filter: "System Support",
    title: "Help Desk & Technical Support",
    description:
      "Provided technical assistance, troubleshooting, and user support to ensure efficient issue resolution and user satisfaction.",
  },
];

function StatIcon({ type }) {
  const commonProps = {
    className: "h-8 w-8",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
  };

  if (type === "briefcase") {
    return (
      <svg {...commonProps}>
        <path d="M9 6V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1" />
        <path d="M4 7h16v12H4z" />
        <path d="M4 12h16" />
        <path d="M10 12v2h4v-2" />
      </svg>
    );
  }

  if (type === "users") {
    return (
      <svg {...commonProps}>
        <path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" />
        <path d="M2 21a7 7 0 0 1 14 0" />
        <path d="M17 11a3 3 0 1 0-1.6-5.5" />
        <path d="M19 21a5 5 0 0 0-4-4.9" />
      </svg>
    );
  }

  if (type === "star") {
    return (
      <svg {...commonProps}>
        <path d="m12 3 2.7 5.5 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.8 1-6.1-4.4-4.3 6.1-.9L12 3Z" />
      </svg>
    );
  }

  if (type === "code") {
    return (
      <svg {...commonProps}>
        <path d="m8 7-5 5 5 5" />
        <path d="m16 7 5 5-5 5" />
        <path d="m14 4-4 16" />
      </svg>
    );
  }

  if (type === "network") {
    return (
      <svg {...commonProps}>
        <rect x="9" y="3" width="6" height="6" rx="1.5" />
        <rect x="3" y="15" width="6" height="6" rx="1.5" />
        <rect x="15" y="15" width="6" height="6" rx="1.5" />
        <path d="M12 9v3" />
        <path d="M6 15v-3h12v3" />
      </svg>
    );
  }

  return (
    <svg {...commonProps}>
      <path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" />
      <path d="M4 21a8 8 0 0 1 16 0" />
    </svg>
  );
}

function SupportIcon({ type }) {
  const commonProps = {
    className: "h-9 w-9",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
  };

  if (type === "server") {
    return (
      <svg {...commonProps}>
        <rect x="4" y="3" width="16" height="5" rx="1.5" />
        <rect x="4" y="10" width="16" height="5" rx="1.5" />
        <rect x="4" y="17" width="16" height="4" rx="1.5" />
        <path d="M7 5.5h.01M7 12.5h.01M7 19h.01" />
      </svg>
    );
  }

  if (type === "headset") {
    return (
      <svg {...commonProps}>
        <path d="M4 13a8 8 0 0 1 16 0" />
        <path d="M4 13v3a2 2 0 0 0 2 2h1v-7H6a2 2 0 0 0-2 2Z" />
        <path d="M20 13v3a2 2 0 0 1-2 2h-1v-7h1a2 2 0 0 1 2 2Z" />
        <path d="M16 20h-3" />
      </svg>
    );
  }

  if (type === "deployment") {
    return (
      <svg {...commonProps}>
        <rect x="3" y="4" width="18" height="12" rx="2" />
        <path d="M8 20h8M12 16v4" />
        <path d="M17 9v4M15 11h4" />
      </svg>
    );
  }

  if (type === "network") {
    return (
      <svg {...commonProps}>
        <circle cx="12" cy="5" r="2" />
        <circle cx="5" cy="18" r="2" />
        <circle cx="19" cy="18" r="2" />
        <circle cx="12" cy="14" r="2" />
        <path d="M12 7v5M10.3 15.2 6.7 17M13.7 15.2 17.3 17" />
      </svg>
    );
  }

  if (type === "tools") {
    return (
      <svg {...commonProps}>
        <path d="m14.7 6.3 3-3 3 3-3 3" />
        <path d="m3 21 8.5-8.5" />
        <path d="M8 3a5 5 0 0 0 6.8 6.8L20 15l-5 5-5.2-5.2A5 5 0 0 0 3 8" />
      </svg>
    );
  }

  if (type === "help") {
    return (
      <svg {...commonProps}>
        <circle cx="12" cy="12" r="9" />
        <path d="M9.5 9a2.8 2.8 0 0 1 5.2 1.4c0 2-2.7 2.3-2.7 4" />
        <path d="M12 18h.01" />
      </svg>
    );
  }

  if (type === "user") {
    return (
      <svg {...commonProps}>
        <circle cx="12" cy="8" r="4" />
        <path d="M4 21a8 8 0 0 1 16 0" />
      </svg>
    );
  }

  return (
    <svg {...commonProps}>
      <rect x="5" y="4" width="14" height="5" rx="1.5" />
      <rect x="5" y="12" width="14" height="5" rx="1.5" />
      <path d="M12 9v3M8 21h8M12 17v4" />
    </svg>
  );
}

function App() {
  const [activeItem, setActiveItem] = useState("Home");
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeProjectFilter, setActiveProjectFilter] = useState("All Projects");
  const visibleProjects =
    activeProjectFilter === "All Projects"
      ? projects
      : projects.filter((project) => project.filter === activeProjectFilter);

  const handleNavClick = (event, item) => {
    event.preventDefault();
    setActiveItem(item);

    const section = document.getElementById(item.toLowerCase());

    if (!section) {
      return;
    }

    const navbarOffset = 120;
    const sectionTop = section.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: sectionTop - navbarOffset,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 24);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const revealElements = document.querySelectorAll(".reveal");

    if (typeof window !== "undefined" && "IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        (entries, observerInstance) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add("reveal-visible");
            observerInstance.unobserve(entry.target);
          });
        },
        {
          threshold: 0.18,
        }
      );

      revealElements.forEach((element) => observer.observe(element));

      return () => observer.disconnect();
    }

    revealElements.forEach((element) => element.classList.add("reveal-visible"));
  }, []);

  return (
    <div className="Portfolio">
      <nav
        className={`fixed left-1/2 z-50 flex w-[calc(100%-16px)] max-w-[1500px] -translate-x-1/2 items-center justify-between border-b px-4 transition-all duration-300 sm:w-[calc(100%-32px)] sm:px-8 lg:px-10 ${isScrolled
          ? "top-0 rounded-t-none border-white/10 bg-[#04101d]/95 py-3 shadow-[0_16px_45px_rgba(0,0,0,0.35)] backdrop-blur-xl"
          : "top-2 rounded-t-[24px] border-white/5 bg-transparent py-4 sm:top-4"
          }`}
      >
        <a href="/" className="flex items-center gap-3" aria-label="Portfolio home">
          <img src={logo} alt="Logo" className="h-9 w-9 object-contain sm:h-10 sm:w-10" />
          <span>
            <span className="block font-['General_Sans'] text-base font-semibold uppercase text-white">
              Emmanuel Lastimado
            </span>
            <span className="block text-xs font-semibold uppercase tracking-[0.2em] text-cyan-200/80">
              Full Stack Developer/IT Support Specialist
            </span>
          </span>
        </a>

        <div className="hidden items-center gap-7 lg:flex">
          {navItems.map((item) => (
            <a
              key={item}
              href={`#${item.toLowerCase()}`}
              onClick={(event) => handleNavClick(event, item)}
              className="group flex flex-col items-center px-2 font-['Inter'] text-md font-medium text-slate-300 transition hover:text-white"
            >
              <span>{item}</span>
              <span
                className={`h-1.5 w-1.5 mt-1 rounded-full bg-sky-400 shadow-[0_0_10px_rgba(56,189,248,0.85)] transition duration-300 hover:opacity-100 ${activeItem === item
                  ? "opacity-100"
                  : "opacity-0 group-hover:opacity-100"
                  }`}
                aria-hidden="true"
              />
            </a>
          ))}
        </div>

        <a
          href="#contact"
          className="hidden rounded-md border border-white/30 bg-white/10 px-4 py-2 text-sm font-bold text-cyan-100 shadow-lg shadow-cyan-950/40 transition hover:border-white/70 hover:bg-white/20 lg:inline-flex lg:items-center"
        >
          <span>Let's Work Together</span>
          <FaArrowUp className="ml-3 rotate-45 text-xs" aria-hidden="true" />
        </a>
        <button
          className="grid h-12 w-12 place-items-center rounded-xl border border-white/10 bg-white/5 text-white shadow-lg shadow-black/20 lg:hidden"
          aria-label="Open navigation menu"
        >
          <span className="space-y-1.5" aria-hidden="true">
            <span className="block h-0.5 w-6 rounded-full bg-white" />
            <span className="block h-0.5 w-6 rounded-full bg-white" />
            <span className="block h-0.5 w-6 rounded-full bg-white" />
          </span>
        </button>
      </nav>
      <main className="min-h-screen bg-[#02070d] p-2 text-white sm:p-4">
        <div className="mx-auto max-w-[1500px] overflow-hidden rounded-[24px] border border-white/10 bg-[#06111f] shadow-[0_28px_90px_rgba(0,0,0,0.5)]">
          <section id="home" className="relative min-h-[calc(100vh-16px)] overflow-hidden sm:min-h-[calc(100vh-32px)] landing-hero">
            <img
              src={backgroundpage1}
              alt="Developer desk setup"
              className="absolute inset-0 h-full w-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(3,10,18,0.98)_0%,rgba(3,10,18,0.82)_34%,rgba(3,10,18,0.24)_66%,rgba(3,10,18,0.08)_100%),linear-gradient(180deg,rgba(3,10,18,0.62)_0%,rgba(3,10,18,0.05)_34%,rgba(3,10,18,0.75)_100%)]" />
            <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_16%_4%,rgba(45,212,191,0.16),transparent_26%)]" />

            <div className="relative flex min-h-[calc(100vh-16px)] flex-col px-4 pb-4 pt-24 sm:min-h-[calc(100vh-32px)] sm:px-8 sm:pt-28 lg:px-10">
              <section className="flex min-h-0 flex-1 py-3 sm:py-6 lg:py-0 reveal">
                <div className="w-full max-w-[560px] lg:ml-10">
                  <div className="inline-flex items-center gap-2 rounded-full border border-emerald-400/15 bg-emerald-400/10 px-4 py-1.5 mt-5 font-['Inter'] text-sm font-medium text-emerald-300 shadow-[0_0_26px_rgba(16,185,129,0.12)]">
                    <span className="h-2 w-2 rounded-full bg-emerald-400 shadow-[0_0_12px_rgba(52,211,153,0.9)] font-sm" />
                    Available for new opportunities
                  </div>

                  <div className="grid min-h-0 items-center gap-4 sm:py-6 lg:py-18">

                    <h1 className="mt-5 font-['General_Sans'] text-[clamp(2.45rem,5.7vw,2rem)] font-semibold leading-[1.08] tracking-tight text-white">
                      Building Digital Solutions That{" "}
                      <span className="block bg-gradient-to-r from-[#5aa8f7] to-[#83c8f2] bg-clip-text text-transparent">
                        Drive Real Impact.
                      </span>
                    </h1>

                    <p className="mt-5 max-w-[540px] font-['Inter'] text-base font-medium leading-7 text-slate-300 sm:text-lg">
                      I&rsquo;m a Full Stack Web Developer & IT Support Specialist focused on scalable web applications, system deployment, and network administration.
                    </p>

                    <div className="mt-7 flex flex-col gap-4 min-[420px]:flex-row">
                      <a
                        href="#projects"
                        className="inline-flex h-12 items-center justify-center rounded-lg bg-gradient-to-br from-[#8fd4ef] to-[#286fd7] px-7 font-['Inter'] text-base font-medium text-white shadow-[0_18px_34px_rgba(37,99,235,0.3)] transition hover:scale-[1.02]"
                      >
                        View My Work
                        <FaArrowUp className="ml-8 rotate-45 text-sm" aria-hidden="true" />
                      </a>
                      <a
                        href="/cv.pdf"
                        className="inline-flex h-12 items-center justify-center rounded-lg border border-white/15 bg-white/5 px-7 font-['Inter'] text-base font-medium text-white shadow-lg shadow-black/20 transition hover:border-white/35 hover:bg-white/10"
                      >
                        Download CV
                        <svg
                          className="ml-8 h-5 w-5"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          aria-hidden="true"
                        >
                          <path d="M12 3v12" />
                          <path d="m7 10 5 5 5-5" />
                          <path d="M5 21h14" />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </section>

              <div className="shrink-0 rounded-xl border border-white/10 bg-[#07111f]/70 px-8 py-4 shadow-[0_24px_60px_rgba(0,0,0,0.32)] backdrop-blur-md sm:px-6 lg:mx-10 lg:mb-8 lg:px-6 lg:py-5 reveal">
                <div className="grid gap-0 lg:grid-cols-4">
                  {stats.map((stat, index) => (
                    <div
                      key={stat.label}
                      className={`flex items-center gap-4 py-3 lg:px-7 lg:py-0 ${index > 0
                        ? "border-t border-white/10 lg:border-l lg:border-t-0"
                        : ""
                        }`}
                    >
                      <span className="grid h-8 w-8 shrink-0 place-items-center rounded-lg border border-white/10 bg-white/5 text-white shadow-lg shadow-black/20 sm:h-12 sm:w-12 [&_svg]:h-6 [&_svg]:w-6">
                        <StatIcon type={stat.icon} />
                      </span>
                      <span>
                        <span className="block font-['General_Sans'] text-xl font-bold leading-tight text-white lg:text-2xl">
                          {stat.value}
                        </span>
                        <span className="mt-1 block font-['Inter'] text-xs font-medium text-slate-300 lg:text-sm">
                          {stat.label}
                        </span>
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          <section className="relative overflow-hidden border-t border-white/10 bg-[#040b14] px-4 py-16 sm:px-8 lg:px-20 lg:py-20 reveal">
            <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_72%_18%,rgba(37,99,235,0.18),transparent_28%)]" />
            <div className="relative mx-auto max-w-7xl">
              <div className="grid items-center gap-12 lg:grid-cols-[0.95fr_1.05fr]">
                <div>
                  <p id="skills" className="font-['Inter'] text-xs font-semibold uppercase tracking-[0.22em] text-sky-400">
                    - My Skills WEB DEVELOPMENT
                  </p>
                  <h2 className="mt-5 font-['General_Sans'] text-4xl font-semibold leading-tight text-white sm:text-5xl">
                    Technologies
                    <span className="block">I Work With</span>
                  </h2>
                  <p className="mt-5 max-w-xl font-['Inter'] text-base leading-7 text-slate-300">
                    I combine creativity with technical expertise to build modern, scalable, and high-performing web applications.
                  </p>

                  <div className="mt-8 flex max-w-md items-center gap-4 rounded-lg border border-white/10 bg-white/[0.04] p-4 shadow-lg shadow-black/20">
                    <span className="grid h-12 w-12 shrink-0 place-items-center rounded-lg border border-sky-400/20 bg-sky-500/10 text-sky-400">
                      <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="m13 2-8 12h7l-1 8 8-12h-7l1-8Z" />
                      </svg>
                    </span>
                    <p className="font-['Inter'] text-sm leading-6 text-slate-300">
                      <span className="block font-semibold text-white">Always exploring new technologies</span>
                      to build better digital experiences.
                    </p>
                  </div>
                </div>

                <div className="relative min-h-[300px] overflow-hidden bg-[#040b14]">
                  <div className="pointer-events-none absolute inset-0 z-20 bg-[linear-gradient(90deg,#040b14_0%,rgba(4,11,20,0)_14%,rgba(4,11,20,0)_86%,#040b14_100%),linear-gradient(180deg,#040b14_0%,rgba(4,11,20,0)_18%,rgba(4,11,20,0)_82%,#040b14_100%)]" />
                  <img
                    src={backgroundskill1}
                    alt="Code editor technology preview"
                    className="relative z-10 ml-auto w-full max-w-[650px] object-contain mix-blend-lighten"
                  />
                </div>
              </div>

              <div className="mt-14 grid gap-5 lg:grid-cols-2">
                <div className="rounded-lg border border-white/10 bg-[#07111f]/70 p-5 shadow-[0_24px_60px_rgba(0,0,0,0.28)]">
                  <h3 className="font-['General_Sans'] text-lg font-semibold text-white">
                    Technical Skills
                  </h3>
                  <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-4">
                    {technicalSkills.map((skill, index) => {
                      const Icon = skill.icon;

                      return (
                        <div
                          key={skill.name}
                          className="skill-pop grid min-h-28 place-items-center rounded-lg border border-white/5 bg-white/[0.03] p-4 text-center shadow-lg shadow-black/10"
                          style={{ "--pop-delay": `${index * 80}ms` }}
                        >
                          <Icon className={`h-9 w-9 ${skill.color}`} aria-hidden="true" />
                          <span className="mt-3 font-['Inter'] text-sm font-medium text-slate-200">
                            {skill.name}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                  <a href="#projects" className="mx-auto mt-6 inline-flex items-center justify-center font-['Inter'] text-sm font-medium text-sky-400 transition hover:text-sky-300">
                    More Technologies
                    <FaArrowUp className="ml-3 rotate-45 text-xs" aria-hidden="true" />
                  </a>
                </div>

                <div className="rounded-lg border border-white/10 bg-[#07111f]/70 p-5 shadow-[0_24px_60px_rgba(0,0,0,0.28)]">
                  <h3 className="font-['General_Sans'] text-lg font-semibold text-white">
                    Core Competencies
                  </h3>
                  <div className="mt-5 space-y-5">
                    {competencies.map((competency, index) => (
                      <div key={competency.name}>
                        <div className="mb-2 flex items-center justify-between gap-4 font-['Inter'] text-sm">
                          <span className="flex items-center gap-2 text-slate-200">
                            <span className="h-1.5 w-1.5 rounded-full bg-sky-400" />
                            {competency.name}
                          </span>
                          <span className="text-slate-300">{competency.value}%</span>
                        </div>
                        <div className="h-1 rounded-full bg-white/10">
                          <div
                            className="progress-fill h-full rounded-full bg-gradient-to-r from-[#5aa8f7] to-[#2877f2]"
                            style={{
                              "--progress-width": `${competency.value}%`,
                              "--progress-delay": `${index * 90 + 180}ms`,
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="relative mx-auto max-w-7xl">
              <div className="grid items-center gap-12 lg:grid-cols-[0.95fr_1.05fr]">
                <div>
                  <p className="font-['Inter'] text-xs font-semibold uppercase tracking-[0.22em] text-sky-400">
                    - My Skills IT Support Specialist
                  </p>
                  <h2 className="mt-5 font-['General_Sans'] text-4xl font-semibold leading-tight text-white sm:text-5xl">
                    Systems
                    <span className="block">I Support</span>
                  </h2>
                  <p className="mt-5 max-w-xl font-['Inter'] text-base leading-7 text-slate-300">
                    Providing reliable IT support, system deployment, and network assistance to keep users productive and operations running smoothly.
                  </p>

                  <div className="mt-8 flex max-w-md items-center gap-4 rounded-lg border border-white/10 bg-white/[0.04] p-4 shadow-lg shadow-black/20">
                    <span className="grid h-12 w-12 shrink-0 place-items-center rounded-lg border border-sky-400/20 bg-sky-500/10 text-sky-400">
                      <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="m13 2-8 12h7l-1 8 8-12h-7l1-8Z" />
                      </svg>
                    </span>
                    <p className="font-['Inter'] text-sm leading-6 text-slate-300">
                      <span className="block font-semibold text-white">Always learning, always solving.</span>
                      Delivering efficient and reliable IT support.
                    </p>
                  </div>
                </div>

                <div className="relative min-h-[300px] overflow-hidden bg-[#040b14]">
                  <div className="pointer-events-none absolute inset-0 z-20 bg-[linear-gradient(90deg,#040b14_0%,rgba(4,11,20,0)_14%,rgba(4,11,20,0)_86%,#040b14_100%),linear-gradient(180deg,#040b14_0%,rgba(4,11,20,0)_18%,rgba(4,11,20,0)_82%,#040b14_100%)]" />
                  <img
                    src={backgroundskill2}
                    alt="IT support system preview"
                    className="relative z-10 ml-auto w-full max-w-[650px] object-contain mix-blend-lighten"
                  />
                </div>
              </div>

              <div className="mt-14 grid gap-5 lg:grid-cols-2">
                <div className="rounded-lg border border-white/10 bg-[#07111f]/70 p-5 shadow-[0_24px_60px_rgba(0,0,0,0.28)]">
                  <h3 className="font-['General_Sans'] text-lg font-semibold text-white">
                    IT Support Skills
                  </h3>
                  <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-4">
                    {itSupportSkills.map((skill, index) => (
                      <div
                        key={skill.name}
                        className="skill-pop grid min-h-32 place-items-center rounded-lg border border-white/5 bg-white/[0.03] p-4 text-center shadow-lg shadow-black/10"
                        style={{ "--pop-delay": `${index * 80}ms` }}
                      >
                        <span className="text-sky-400">
                          <SupportIcon type={skill.icon} />
                        </span>
                        <span className="mt-3 font-['Inter'] text-sm font-semibold text-slate-100">
                          {skill.name}
                        </span>
                        <span className="mt-1 font-['Inter'] text-xs leading-4 text-slate-400">
                          {skill.label}
                        </span>
                      </div>
                    ))}
                  </div>
                  <a href="#experience" className="mx-auto mt-6 inline-flex items-center justify-center font-['Inter'] text-sm font-medium text-sky-400 transition hover:text-sky-300">
                    More IT Support Skills
                    <FaArrowUp className="ml-3 rotate-45 text-xs" aria-hidden="true" />
                  </a>
                </div>

                <div className="rounded-lg border border-white/10 bg-[#07111f]/70 p-5 shadow-[0_24px_60px_rgba(0,0,0,0.28)]">
                  <h3 className="font-['General_Sans'] text-lg font-semibold text-white">
                    Core Competencies
                  </h3>
                  <div className="mt-5 space-y-5">
                    {itSupportCompetencies.map((competency, index) => (
                      <div key={competency.name}>
                        <div className="mb-2 flex items-center justify-between gap-4 font-['Inter'] text-sm">
                          <span className="flex items-center gap-2 text-slate-200">
                            <span className="h-1.5 w-1.5 rounded-full bg-sky-400" />
                            {competency.name}
                          </span>
                          <span className="text-slate-300">{competency.value}%</span>
                        </div>
                        <div className="h-1 rounded-full bg-white/10">
                          <div
                            className="progress-fill h-full rounded-full bg-gradient-to-r from-[#5aa8f7] to-[#2877f2]"
                            style={{
                              "--progress-width": `${competency.value}%`,
                              "--progress-delay": `${index * 90 + 180}ms`,
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section id="projects" className="relative overflow-hidden border-t border-white/10 bg-[#020812] px-4 py-16 sm:px-8 lg:px-20 lg:py-20 reveal">
            <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_24%_12%,rgba(14,165,233,0.16),transparent_30%),radial-gradient(circle_at_80%_34%,rgba(37,99,235,0.13),transparent_28%)]" />
            <div className="relative mx-auto max-w-7xl">
              <div className="grid gap-8 lg:grid-cols-[0.82fr_1fr] lg:items-start">
                <div>
                  <p className="flex items-center gap-3 font-['Inter'] text-xs font-semibold uppercase tracking-[0.22em] text-sky-400">
                    <span className="h-px w-6 bg-sky-400" />
                    My Projects
                  </p>
                  <h2 className="mt-5 font-['General_Sans'] text-4xl font-semibold leading-tight text-white sm:text-5xl lg:text-6xl">
                    Projects
                  </h2>
                  <p className="mt-5 max-w-md font-['Inter'] text-base leading-7 text-slate-300">
                    A collection of web development projects focused on creating responsive, user-friendly, and efficient digital solutions.
                  </p>
                </div>

                <div className="flex flex-wrap gap-3 rounded-2xl border border-white/10 bg-[#07111f]/70 p-3 shadow-[0_24px_60px_rgba(0,0,0,0.28)] backdrop-blur-md lg:justify-between">
                  {projectFilters.map((filter) => (
                    <button
                      key={filter}
                      type="button"
                      onClick={() => setActiveProjectFilter(filter)}
                      className={`min-h-10 rounded-full px-5 font-['Inter'] text-sm font-medium transition ${activeProjectFilter === filter
                        ? "bg-sky-500/20 text-sky-300 shadow-[inset_0_0_0_1px_rgba(14,165,233,0.14),0_10px_28px_rgba(14,165,233,0.12)]"
                        : "text-slate-300 hover:bg-white/5 hover:text-white"
                        }`}
                    >
                      {filter}
                    </button>
                  ))}
                </div>
              </div>

              {/* <div className="mt-12 grid gap-5 md:grid-cols-2 xl:grid-cols-3">
                {visibleProjects.map((project, index) => (
                  <article
                    key={project.title}
                    className="project-card flex min-h-[250px] flex-col rounded-xl border border-white/10 bg-[#07111f]/70 p-7 shadow-[0_24px_60px_rgba(0,0,0,0.28)] transition duration-300 hover:-translate-y-1 hover:border-sky-400/30 hover:bg-[#0a1728]/85"
                    style={{ "--project-delay": `${index * 70}ms` }}
                  >
                    <div className="flex items-start gap-4">
                      <span className="grid h-16 w-16 shrink-0 place-items-center rounded-xl border border-sky-400/20 bg-sky-500/10 text-sky-400 shadow-[inset_0_0_24px_rgba(14,165,233,0.1)]">
                        <SupportIcon type={project.icon} />
                      </span>
                      <div className="min-w-0 pt-2">
                        <p className="font-['Inter'] text-xs font-semibold uppercase tracking-[0.16em] text-sky-400">
                          {project.category}
                        </p>
                        <h3 className="mt-3 font-['General_Sans'] text-lg font-semibold leading-snug text-white">
                          {project.title}
                        </h3>
                      </div>
                    </div>

                    <p className="mt-5 flex-1 font-['Inter'] text-base leading-7 text-slate-300">
                      {project.description}
                    </p>

                    <a
                      href="#contact"
                      className="mt-5 inline-flex items-center border-t border-white/10 pt-5 font-['Inter'] text-sm font-medium text-sky-400 transition hover:text-sky-300"
                    >
                      View Details
                      <FaArrowUp className="ml-3 rotate-45 text-xs" aria-hidden="true" />
                    </a>
                  </article>
                ))}
              </div> */}

              <div className="mt-9 flex justify-center">
                <a
                  href="#contact"
                  className="inline-flex h-12 items-center justify-center rounded-full border border-sky-400/20 bg-[#07111f]/70 px-9 font-['Inter'] text-sm font-medium text-sky-400 shadow-[0_18px_44px_rgba(0,0,0,0.24)] transition hover:border-sky-300/40 hover:bg-sky-500/10 hover:text-sky-300"
                >
                  View All Projects
                  <FaArrowUp className="ml-4 rotate-45 text-xs" aria-hidden="true" />
                </a>
              </div>
            </div>
          </section>

        </div>
      </main>
    </div>
  );
}

export default App;
